import React, { Component } from 'react'
import styled from 'styled-components'
import defaultTheme from '@ntuctech/devex-tangram/Theme/defaultTheme'
import SvgOfferExpand from '../icons/svgOfferExpand'
import Text from '../Text/Text'
import PromoOfferEndsInCounter from './promoOfferEndsInCounter'
import Router from 'next/router'
import { EventTrackingConsumer } from '../EventTrackingProvider/EventTrackingProvider'
import { GTM_ENV_VAR as GEV } from '../../lib/eventTrackerFunction'

import { getConfigFor } from '../../utils/configService'
import { SPLIT_FEATURES } from '../../utils/constants'

const MOVEBYPIXELS = 30
const DURATION = 20
const MOBILESCREENLIMIT = 768

const PlainContainer = styled.div`
  display: block;

  > a {
    text-decoration: none;
  }
`

const OfferContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.5rem 1rem;
  border: 0.0625rem solid #ea6100;
  border-radius: 0.3rem;
`
const OfferImageAndDetails = styled.div`
  display: flex;
  align-items: center;
  flex: 90%;
`

const OfferDetails = styled.div`
  display: table;
  flex-direction: column;
`

const OfferHeading = styled.h2`
  color: ${defaultTheme.ColorBaseBrandSecondary500};
`
const OfferSubHeading = styled.p`
  color: ${defaultTheme.ColorBaseMineShaft500};
  padding-top: 0.25rem;
`
const PromoDiv = styled.div`
  cursor: ${props => (props.cursor ? 'pointer' : 'default')};
`
const OfferWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
`

const MemberIngestionDiv = styled.div`
  display: flex;
`

const LPIcon = styled.img`
  margin-left: ${props => props.left};
  margin-right: ${props => props.right};
  width: ${props => props.width};
  height: ${props => props.height};
`

const DigitalClubPromo = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.25rem;
`

const RedeemLabelDiv = styled.div`
  cursor: pointer;
  text-decoration: none;
`
class PromoOffers extends Component {
  constructor() {
    super()
    this.state = {
      modalOpen: false,
    }

    this.handleSmoothScroll = this.handleSmoothScroll.bind(this)
    this.scrollWrapper = this.scrollWrapper.bind(this)
    this.handleRedirect = this.handleRedirect.bind(this)
  }

  handleRedirect(event) {
    const { track, clientItemId, name } = this.props
    track({
      [GEV.EVENT_CAT]: 'PromotionFunnel',
      [GEV.EVENT_ACTION]: 'PromotionClick',
      [GEV.EVENT_LABEL]: 'PromoText_Text Link - Digital Club',
      [GEV.SCREEN_NAME]: `ProductListing - ${name}`,
      [GEV.PAGE_TYPE]: 'Product',
      [GEV.UTM_CONTENT]: clientItemId.toString(),
    })
    Router.push('/membership/registration')
    event.stopPropagation()
  }

  scrollWrapper(name) {
    const elem = document.getElementById(name)
    if (elem) {
      const elemPosition =
        elem.getBoundingClientRect().top + document.documentElement.scrollTop
      const innerWidthOfWindow = window.innerWidth
      const header = document.getElementsByTagName('header')
      let headerHeight = 0

      // header height need to be subtracted only in case of small screen as we have header absolute positined
      if (innerWidthOfWindow < MOBILESCREENLIMIT) {
        if (header && header[0]) {
          headerHeight = header[0].getBoundingClientRect().height
        }
      }
      this.handleSmoothScroll(elemPosition, headerHeight)
    }
  }

  handleSmoothScroll(elemPosition, headerHeight, lastVale) {
    //becuase IE11 doesnot support window.scrollY
    const scrollY = window.scrollY || window.pageYOffset
    const _this = this
    if (scrollY < Math.floor(elemPosition - headerHeight)) {
      setTimeout(function () {
        let addValue = 0
        if (scrollY + headerHeight + MOVEBYPIXELS > elemPosition) {
          addValue = elemPosition - headerHeight
        } else {
          addValue = scrollY + MOVEBYPIXELS
        }
        document.documentElement.scrollTop = addValue

        // avoid infinite loop
        if (addValue === lastVale) {
          return
        }
        _this.handleSmoothScroll(elemPosition, headerHeight, addValue)
      }, DURATION)
    }
  }

  render() {
    const { data, showArrow } = this.props
    const { description, imageUrl, validTill } = data

    const { configuration: digitalClubConfig } = getConfigFor(
      SPLIT_FEATURES.DC_CONFIG
    )

    let digitalClubPromoFlag = false

    if (
      Array.isArray(data?.userSet?.data) &&
      String(data?.userSet?.data[0]?.tagId) ===
        String(digitalClubConfig?.offerTagId)
    ) {
      digitalClubPromoFlag = true
    }
    return (
      <PlainContainer>
        <PromoDiv
          cursor={showArrow}
          onClick={() =>
            this.scrollWrapper(this.props.data && this.props.data.id)
          }
        >
          <OfferContainer>
            {digitalClubPromoFlag && (
              <DigitalClubPromo data-testid="DC-Promo-Offer">
                <MemberIngestionDiv>
                  <LPIcon
                    alt="Digital Club"
                    width="1.125rem"
                    height="1.125rem"
                    src={digitalClubConfig?.iconUrl}
                  />
                  {digitalClubConfig?.pdpOfferLabel && (
                    <Text
                      size="medium"
                      color={defaultTheme.ColorBaseMineShaft700}
                    >
                      {digitalClubConfig?.pdpOfferLabel}
                    </Text>
                  )}
                </MemberIngestionDiv>
                {!data?.isDBMember && (
                  <RedeemLabelDiv onClick={this.handleRedirect}>
                    <Text size="medium" color="#1557BF" weight="bold">
                      {digitalClubConfig?.joinToRedeemLabel}
                    </Text>
                  </RedeemLabelDiv>
                )}
              </DigitalClubPromo>
            )}
            <OfferWrapper>
              <OfferImageAndDetails>
                <OfferDetails margin={imageUrl ? 'default' : '0 1rem 0 0rem'}>
                  {description && (
                    <OfferHeading>
                      <Text
                        size="small"
                        weight="bold"
                        color={defaultTheme.ColorBaseBrandSecondary500}
                      >
                        {description}
                      </Text>
                    </OfferHeading>
                  )}
                  {validTill && (
                    <OfferSubHeading>
                      <PromoOfferEndsInCounter validTill={validTill} />
                    </OfferSubHeading>
                  )}
                </OfferDetails>
              </OfferImageAndDetails>
              {showArrow && <SvgOfferExpand width="20" height="20" />}
            </OfferWrapper>
          </OfferContainer>
        </PromoDiv>
      </PlainContainer>
    )
  }
}

const PromoOffersWrapper = props => (
  <EventTrackingConsumer>
    {({ track }) => <PromoOffers {...props} track={track} />}
  </EventTrackingConsumer>
)

export default PromoOffersWrapper
